module.exports = __webpack_public_path__ + "static/media/Home_IT.5f28964f.jpg";